// The default masthead height is not necessarily the actual masthead
// height, please use `getMastheadHeight` from utils/mastheadHeight.js
// if you need the actual runtime masthead height.
const defaultMastheadHeight = '64px';

export default defaultMastheadHeight;
